import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';

import Modal from 'react-modal';
import {Button} from '../Button';

import {
  Title,
  StyledText,
  CloseButton,
  getOverlayStyles,
  getContentStyles,
  getButtonContentStyles,
  HeaderWrapper
} from './styles';

//messages
import messages from './messages';

@inject('store')
@observer
class ForgotWorkspacePasswordDialog extends Component {
  render() {
    const {intl, isMobile, store} = this.props;
    const {formatMessage} = intl;
    const {forgotWorkspacePasswordDialog} = store;
    const {opened, closeDialog} = forgotWorkspacePasswordDialog;

    const styles = {
      overlay: getOverlayStyles(),
      content: getContentStyles(isMobile)
    };

    const buttonStyle = {
      content: getButtonContentStyles()
    };
    return (
      <Modal isOpen={opened} onRequestClose={closeDialog} style={styles}>
        <HeaderWrapper isMobile={isMobile}>
          <Title isMobile={isMobile}>{formatMessage(messages.forgotWorkspacePasswordDialog)}</Title>
          <CloseButton isMobile={isMobile} onClick={closeDialog} />
        </HeaderWrapper>
        <StyledText isMobile={isMobile}>{formatMessage(messages.contactAdmin)}</StyledText>
        <Button style={buttonStyle} type="submit" onClick={closeDialog}>
          {formatMessage(messages.returnToSignIn)}
        </Button>
      </Modal>
    );
  }
}
export default injectIntl(ForgotWorkspacePasswordDialog);
